module.exports = __webpack_public_path__ + "img/tire_package.7aae2d24.svg";